var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.config),expression:"config"}],staticClass:"right-bar"}),_c('div',{staticClass:"rightbar-overlay"})])}
var staticRenderFns = []

export { render, staticRenderFns }